import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import { A_ASSOCIATES_TYPES } from "@/src-refactor/modules/shared/model/const/property/associates-types.conts";
import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { A_CONDICTION_PROPERTY } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";
import { A_PROPERTY_TYPES_FOR_PROJECT } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { A_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { Grid } from "@mui/material";
import HCheckArray from "@rf-helper/check-have-value";
import MxTypography from "@rf-l1/MxTypography";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import MxTooltipNormal from "@rf-l1/tooltip/MxTooltipNormal";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectArrangementsTypeField from "@rf-l2/form/select/MxFormSelectArragementsField";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import MxFormL3CheckField from "@rf-l3/form/MxFormL3CheckBoxField";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import { IEventChange } from "@rf-model/event-change.model";
import usePropertyFormHelp from "@rf/property/module/components/property-form/hooks/helps/usePropertyFormHelp";
import usePropertyHelpTypeLocations from "@rf/property/module/components/property-form/hooks/helps/usePropertyHelpTypeLocations";
import { usePropertyFormFeaturesState } from "@rf/property/module/components/property-form/store/slices/FormFeaturesSlice";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useFormContext } from "react-hook-form";

const BusinessDataFormSectionForProject = () => {
  const { PROPERTY_PROJECT_TYPE } = usePropertyFormHelp();

  const { isEdit } = usePropertyHelpTypeLocations();
  const { feature } = usePropertyFormFeaturesState();
  const { trigger } = useFormContext();
  const { userIsAgent } = useUserHasPermission();

  const canEditCollectionField = isEdit
    ? PROPERTY_PROJECT_TYPE.APARTMENT || PROPERTY_PROJECT_TYPE.HOUSE
    : false;

  const canEditNameField = isEdit && userIsAgent();
  const show = {
    improvements: HCheckArray(feature?.improvements)
  };

  const handleSelectTypeProperty = (
    e: IEventChange<I_GENERIC_ITEMS[]>,
    value: I_GENERIC_ITEMS[],
    lastSelected?: I_GENERIC_ITEMS
  ) => {
    trigger();
  };
  return (
    <Grid container spacing={2}>
      <Grid container item xs={12}>
        <MxFormSubTitle label="Datos del Negocio" isRequired />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.type_property}
          label="Tipo de proyecto"
          items={A_PROPERTY_TYPES_FOR_PROJECT}
          onSelect={handleSelectTypeProperty}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxTooltipNormal
          label="Ingrese únicamente el nombre del condominio, edificio, torre o residencial"
          placement="top-start"
        >
          <span>
            <MxFormL3InputField
              withreacthookform={1}
              name={CPropertyFormKeys.name_property}
              label="Nombre de la propiedad"
              disabled={canEditNameField}
            />
          </span>
        </MxTooltipNormal>
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormFieldController
          withreacthookform={1}
          name={CPropertyFormKeys.arrangement_type_property}
        >
          <MxFormSelectArrangementsTypeField label="Tipo de arreglo" />
          <MxFormErrorMessage />
        </MxFormFieldController>
      </Grid>

      {/* <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.business_types_property}
          label="Tipo de negocio"
          items={[C_BUSINESS_TYPE.SALE]}
          disabled
        />
      </Grid> */}

      <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.associates_type_property}
          items={A_ASSOCIATES_TYPES}
          label="Asociados"
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.condition_property}
          label="Estado del inmueble"
          items={A_CONDICTION_PROPERTY}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <UsesField />
      </Grid>
      {show.improvements && (
        <Grid item xs={12} lg={4}>
          <MxFeatureProject />
        </Grid>
      )}

      <Grid item xs={12} lg={4}>
        <MxFormL3CheckField
          withreacthookform={1}
          name={CPropertyFormKeys.master_broker_property}
          label="Master Broker"
        />
      </Grid>
      {canEditCollectionField && (
        <Grid item xs={12} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.is_collection_property}
            label="¿Esta propiedad es THE RE/MAX COLLECTION?"
            items={A_YES_AND_NOT}
          />
        </Grid>
      )}
    </Grid>
  );
};

const UsesField = () => {
  const { feature } = usePropertyFormFeaturesState();

  return (
    <MxFormL3AutoComplete
      withreacthookform={1}
      name={CPropertyFormKeys.uses_property}
      label="Uso del inmueble"
      items={feature?.usage || []}
      isMultiple
    />
  );
};

const MxFeatureProject = () => {
  const { feature } = usePropertyFormFeaturesState();
  return (
    <MxFormL3AutoComplete
      withreacthookform={1}
      name={CPropertyFormKeys.features_property}
      label="Mejoras del proyecto"
      items={feature?.improvements || []}
      isMultiple
    />
  );
};

export default BusinessDataFormSectionForProject;
